/* eslint-disable @typescript-eslint/no-explicit-any */
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";

const Direccion = ({ setForm, form }: any) => {
  const onChange = async (e: any) => {
    switch (e.target.name) {
      case "address_line_four":
      case "address_line_three":
      case "floor":
      case "postal_code":
      case "city":
      case "province":
      case "country":
      case "address":
        {
          setForm({
            ...form,
            [e.target.name]: e.target.value,
          });
        }
        break;
      case "show_location":
        {
          const params = new URLSearchParams({
            city: form.city,
            country: form.country,
            postalcode: form.postal_code,
            street: form.address,
            format: "json",
          });
          const response = await fetch(
            `https://nominatim.openstreetmap.org/search?${params}`
          ).then(async (res) => {
            const result = await res.json();
            return result[0];
          });

          setForm({
            ...form,
            [e.target.name]: e.target.checked,
            coordinates: [response.lat, response.lon],
            lat: response.lat,
            lon: response.lon
          });
        }
        break;
      default:
        break;
    }
  };


  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 py-5 px-5">
      <div>
        <span className="font-bold text-black mb-2 block">
          Confirmanos tu dirección
        </span>
        <div className="grid grid-cols-1 gap-5">
          <span>
            Solo vamos a compartir tu dirección con los huéspedes luego de que
            hagan la reserva.
          </span>
          <div>
            <select
              className="bg-white border border-black text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-black block w-full p-2.5 dark:placeholder-gray-400 dark:text-white dark:focus:ring-black-500 dark:focus:border-black-500"
              name="country"
              onChange={(event) => onChange(event)}
            >
              <option selected>Argentina - AR</option>
              <option value="Argentina">Argentina - AR</option>
            </select>
          </div>

          <input
            type="text"
            className="bg-white border text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-black block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500  border-black"
            placeholder="Dirección"
            name="address"
            onChange={(event) => onChange(event)}
          />

          <input
            type="text"
            className="bg-white border text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-black block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500  border-black"
            placeholder="Departamento, piso, edificio (Si corresponde)"
            name="floor"
            onChange={(event) => onChange(event)}
          />

          <input
            type="text"
            className="bg-white border text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-black block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500  border-black hidden"
            placeholder="Dirección línea 3 (Si corresponde)"
            name="address_line_three"
            onChange={(event) => onChange(event)}
          />

          <input
            type="text"
            className="bg-white border text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-black block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500  border-black hidden"
            placeholder="Dirección línea 4 (Si corresponde)"
            name="address_line_four"
            onChange={(event) => onChange(event)}
          />

          <input
            type="text"
            className="bg-white border text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-black block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500  border-black"
            placeholder="Localidad"
            name="city"
            onChange={(event) => onChange(event)}
          />

          <input
            type="text"
            className="bg-white border text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-black block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500  border-black"
            placeholder="Provincia"
            name="province"
            onChange={(event) => onChange(event)}
          />

          <input
            type="text"
            className="bg-white border text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-black block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500  border-black"
            placeholder="Código postal (Si corresponde)"
            name="postal_code"
            onChange={(event) => onChange(event)}
          />
          <hr />
          <div className="w-full">
            <label className="w-full inline-flex items-center cursor-pointer justify-between">
              <input
                type="checkbox"
                value=""
                className="sr-only peer"
                name="show_location"
                onChange={(event) => onChange(event)}
              />
              <div className="ms-3 text-sm font-medium text-gray-900 dark:text-gray-300 w-[500px]">
                <span className="block font-bold">
                  Mostrá tu ubicación exacta
                </span>
                <span>
                  Indicales a los huéspedes de forma clara dónde se encuentra tu
                  alojamiento. Solo vamos a darles tu dirección una vez que haya
                  hecho la reserva.
                </span>
              </div>
              <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer  peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-primary"></div>
            </label>
          </div>
        </div>
      </div>
      <div className="overflow-hidden">
        {form.show_location ? (
          <div
            className="overflow-hidden"
            style={{ width: "100%", height: "400px", zIndex: 1 }}
          >
            <MapContainer
              center={form.coordinates}
              zoom={13}
              style={{ height: "100%", width: "100%", zIndex: 1 }}
            >
              <TileLayer
                url={"https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png"}
                attribution=""
              />

              {/* Marcador */}
              <Marker position={form.coordinates} >
                <Popup>{`${form.address},${form.city} ${form.province} ${form.country}`}</Popup>
              </Marker>
            </MapContainer>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default Direccion;
